// src/components/LevelRouter.js
import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

import MaleLevelPage from "./MaleLevelPage/MaleLevelPage";
import FemaleLevelPage from "./FemaleLevelPage/FemaleLevelPage";

export default function LevelRouter() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const user = auth.currentUser;

    if (!user) {
      setLoading(false);
      return;
    }

    const loadProfile = async () => {
      try {
        const snap = await getDoc(doc(db, "users", user.uid));
        if (snap.exists()) {
          setProfile(snap.data());
        }
      } catch (e) {
        console.error("Failed to load profile:", e);
      } finally {
        setLoading(false);
      }
    };

    loadProfile();
  }, []);

  if (loading) return null;
  if (!profile) return null;

  if (profile.gender === "female") {
    return <FemaleLevelPage />;
  }

  return <MaleLevelPage user={profile} />;
}